/**
 * Product count for predictive search "see all" link (storefront first, predictive fallback).
 */
window.SearchUtils = {
  predictiveUrl(term, sectionId, limit = 10) {
    const params =
      `q=${encodeURIComponent(term)}` +
      `&section_id=${sectionId}` +
      '&resources[type]=product' +
      `&resources[limit]=${limit}` +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor';

    return `${window.routes.predictive_search_url}?${params}`;
  },

  fetchStorefrontTotal(searchPageUrl) {
    const url = new URL(searchPageUrl, window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', 'search-product-count');

    return fetch(url.toString())
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return 0;
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-total]');
        return parseInt(el?.getAttribute('data-product-total') || '0', 10);
      })
      .catch(() => 0);
  },

  fetchPredictiveTotal(term) {
    if (!term || !window.routes?.predictive_search_url) return Promise.resolve(0);

    return fetch(this.predictiveUrl(term, 'search-predictive-fallback', 10))
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return 0;
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-total]');
        return parseInt(el?.getAttribute('data-total') || '0', 10);
      })
      .catch(() => 0);
  },

  fetchProductTotal(term, searchPageUrl) {
    return this.fetchStorefrontTotal(searchPageUrl).then((total) => {
      if (total > 0) return total;
      return this.fetchPredictiveTotal(term);
    });
  },
};
